import React, { useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/img/mobile-brand.jpg";
import { Icon, Modal, Menu, Sidebar } from "semantic-ui-react";
import { useLogout } from "../../Hooks/useLogout";
import { useAuthContext } from "../../Hooks/useAuthContext";
import { useMetaData } from "../../Context/MetaDataContext";
import { SearchTickerContext } from "../../Context/SearchTickerContext";
import { isMobile } from "react-device-detect";
import TickerModal from "../Modal/TickerModal";
import FavoriteTickers from "../Tickers/FavoriteTickers";
const NavBar = () => {
  const { logout } = useLogout();
  const { user } = useAuthContext();
  const { metaData } = useMetaData();
  const [open, setOpen] = useState(false);
  const {
    value,
    setValue,
    setSearchResults,
    handleTickerInput,
  } = useContext(SearchTickerContext);
  const [visible, setVisible] = useState(false);
  const handleClear = () => {
    setValue("");
    setSearchResults([]);
  };
  const handleLogout = () => {
    logout();
    setVisible(false);
  };
  const handleSidebarHide = () => {
    setVisible(false);
  };
  const handleToggle = () => {
    setVisible(true);
  };
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Chào buổi sáng" : hour < 18 ? "Chào buổi chiều" : "Chào buổi tối";
  const displayName = (user?.user?.global_name || user?.user?.username || "bạn").split(" ")[0];
  const linkClass = ({ isActive }) => (isActive ? "is-active" : undefined);
  return (
    <>
      <header className="desk-bar">
        <div className="desk-bar__inner">
          <Link className="desk-brand" to="/">
            <img src={logo} alt="" />
            <span>
              WeWinTogether
              <small>One team · One dream · One victory</small>
            </span>
          </Link>
          <nav className="desk-links" aria-label="Primary">
            <NavLink end className={linkClass} to="/">
              {metaData.WELCOME.HOME}
            </NavLink>
            <NavLink className={linkClass} to="/hub">
              {metaData.WELCOME.MARKET_HUB}
            </NavLink>
            <NavLink className={linkClass} to="/class">
              Class
            </NavLink>
            <NavLink className={linkClass} to="/podcast">
              Podcast
            </NavLink>
            <NavLink className={linkClass} to="/breaking">
              {metaData.WELCOME.MARKET_BREAKING_NEWS}
            </NavLink>
            <NavLink className={linkClass} to="/calendar">
              {metaData.WELCOME.MARKET_MAJOR_EVENT}
            </NavLink>
          </nav>
          <div className="desk-tools">
            {!isMobile && (
              <label className="desk-search">
                <Icon name="search" />
                <input
                  type="text"
                  placeholder={metaData.TEXT.SEARCH}
                  value={value}
                  onChange={handleTickerInput}
                />
                {value.length > 0 && (
                  <button type="button" onClick={handleClear} aria-label="Clear search">
                    <Icon name="close" />
                  </button>
                )}
              </label>
            )}
            {user ? (
              <Modal
                onClose={() => setOpen(false)}
                centered={false}
                closeIcon
                onOpen={() => setOpen(true)}
                open={open}
                trigger={
                  <button type="button" className="desk-icon" aria-label="Favorites">
                    <Icon name="star" />
                  </button>
                }
              >
                <FavoriteTickers />
              </Modal>
            ) : (
              <Link className="desk-login" to="/login">
                {metaData.WELCOME.LOGIN_REGISTER || "Login"}
              </Link>
            )}
            <button
              type="button"
              className="desk-icon"
              onClick={handleToggle}
              aria-label="Open menu"
            >
              <Icon name="bars" />
            </button>
          </div>
        </div>
        <div className="app-mobile-welcome">
          <p>{greeting}, <strong>{displayName}</strong></p>
          <blockquote>“Hãy lên kế hoạch giao dịch và giao dịch theo kế hoạch của bạn.” – Linda Raschke</blockquote>
        </div>
      </header>

        <div className="side-bar">
          <Sidebar
            as={Menu}
            className="desk-drawer"
            animation="overlay"
            onHide={handleSidebarHide}
            visible={visible}
            direction="right"
            vertical
            width="thin"
          >
              <Menu.Item onClick={handleSidebarHide}>
                <Icon name="close" />
              </Menu.Item>
              {user && (
                <>
                  <Menu.Item onClick={() => { setOpen(true); handleSidebarHide(); }}>
                    Favorites <Icon name="star" />
                  </Menu.Item>
                  <Menu.Item as={Link} to="/hub" onClick={handleSidebarHide}>
                    {metaData.WELCOME.MARKET_HUB}{" "}
                    <Icon name="chart line" color="green" />
                  </Menu.Item>
                  <Menu.Item as={Link} to="/class" onClick={handleSidebarHide}>
                    Class <Icon name="book" color="brown" />
                  </Menu.Item>
                  <Menu.Item as={Link} to="/podcast" onClick={handleSidebarHide}>
                    Podcast <Icon name="microphone" />
                  </Menu.Item>
                  <Menu.Item
                    as={Link}
                    to="/breaking"
                    onClick={handleSidebarHide}
                  >
                    {metaData.WELCOME.MARKET_BREAKING_NEWS}
                    <Icon name="newspaper" color="red" />
                  </Menu.Item>
                  <Menu.Item
                    as={Link}
                    to="/calendar"
                    onClick={handleSidebarHide}
                  >
                    {metaData.WELCOME.MARKET_MAJOR_EVENT}
                    <Icon name="calendar alternate" />
                  </Menu.Item>

                  {user && user.user.role === 1 && (
                    <Menu.Item>
                      <TickerModal />
                    </Menu.Item>
                  )}
                  <Menu.Item as="a" onClick={handleLogout}>
                    {metaData.WELCOME.LOG_OUT}
                  </Menu.Item>
                </>
              )}

              {!user && (
                <Menu.Item as={Link} to="/podcast" onClick={handleSidebarHide}>
                  Podcast <Icon name="microphone" />
                </Menu.Item>
              )}
              {!user && (
                <Menu.Item as={Link} to="/login" onClick={handleSidebarHide}>
                  {metaData.WELCOME.LOGIN_REGISTER}
                </Menu.Item>
              )}
          </Sidebar>
        </div>
      <nav className="mobile-app-nav" aria-label="Mobile navigation">
        <NavLink end className={linkClass} to="/">
          <Icon name="home" />
          <span>Home</span>
        </NavLink>
        <NavLink className={linkClass} to="/podcast">
          <Icon name="microphone" />
          <span>Podcast</span>
        </NavLink>
        <NavLink className={linkClass} to="/hub">
          <Icon name="chart line" />
          <span>Market</span>
        </NavLink>
        <NavLink className={linkClass} to="/class">
          <Icon name="book" />
          <span>Class</span>
        </NavLink>
        <button type="button" onClick={handleToggle}>
          <Icon name="sidebar" />
          <span>Menu</span>
        </button>
      </nav>
    </>
  );
};

export default NavBar;
